import React from 'react';
import { getMomentumColor, getMomentumLabel, getMomentumSubtext } from '../utils/streaks';

export default function MomentumScore({ score = 0 }) {
  const color = getMomentumColor(score);
  const label = getMomentumLabel(score);
  const subtext = getMomentumSubtext(score);
  const radius = 54;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (score / 100) * circumference;

  return (
    <div className="bg-gradient-to-br from-white to-gray-50 dark:from-gray-800 dark:to-gray-800/60 rounded-2xl p-5 flex items-center gap-5 shadow-sm ring-1 ring-gray-100 dark:ring-gray-700/60">
      <div className="relative w-28 h-28 flex-shrink-0">
        <svg className="w-full h-full -rotate-90" viewBox="0 0 120 120">
          {/* Background circle */}
          <circle
            cx="60"
            cy="60"
            r={radius}
            fill="none"
            stroke="currentColor"
            className="text-gray-100 dark:text-gray-700"
            strokeWidth="8"
          />
          {/* Progress circle */}
          <circle
            cx="60"
            cy="60"
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth="8"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            className="transition-all duration-1000 ease-out"
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-2xl font-bold" style={{ color }}>
            {score}
          </span>
        </div>
      </div>
      <div>
        <p className="text-sm text-gray-500 dark:text-gray-400">Momentum</p>
        <p className="text-lg font-semibold" style={{ color }}>
          {label}
        </p>
        <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">
          {subtext}
        </p>
      </div>
    </div>
  );
}
